var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgPatternCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 780,
    height: 780,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 390,
    cy: 390,
    r: 390
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 390,
    cy: 390,
    r: 390
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#36536B",
    fillRule: "evenodd",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternCircle);
export default __webpack_public_path__ + "static/media/bg-pattern-circle.2f3a4c70060369763a5531031e258e21.svg";
export { ForwardRef as ReactComponent };